import { render, staticRenderFns } from "./followers_tab.vue?vue&type=template&id=48641252"
import script from "./followers_tab.vue?vue&type=script&lang=js"
export * from "./followers_tab.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports